import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import CategoryLeaguesCarousel from './CategoryLeaguesCarousel'
import CategoryLeagues from './CategoryLeagues'
import FollowCategoryBtn from './followButtons/FollowCategoryBtn'
import EventCards from './EventCards'
import { Icon, Switch } from 'antd'

@observer(["CategoriesStore", "ViewStore", "LeagueStore"])
class CategoryEventCards extends Component {
    constructor(props) {
        super(props);

        this.state = {
            categoryId: '',
            events: {},
            leagues: {},
            loading: true,
            loadingLeagues: true
        };
        this.renderEventComponent = this.renderEventComponent.bind(this);
        this.renderEvent = this.renderEvent.bind(this);
        this.handleClickGridList = this.handleClickGridList.bind(this);


    }
    async componentWillMount() {

        const { CategoriesStore, LeagueStore, categoryId } = this.props;
        let self = this;

        self.setState({ categoryId: categoryId })
        CategoriesStore.querySingleCategory(categoryId).then(async () => {

            setTimeout(
                function () {

                    self.setState({ category: Array.from(CategoriesStore.singleCategory.values()) });
                    self.state.category.forEach(function (category) {
                        self.props.ViewStore.changeView(category.title);
                    });

                }.bind(self), 250);

        });

        CategoriesStore.queryCategoryEvents(categoryId).then(async () => {
            setTimeout(
                function () {

                    self.setState({ events: Array.from(CategoriesStore.categoryEvents.values()) })
                }.bind(self), 150);


        });

        LeagueStore.queryCategoryLeagues(categoryId).then(async () => {
            setTimeout(
                function () {
                    self.setState({ leagues: Array.from(LeagueStore.categoryLeagues.values()) })
                    console.log('LEAGUES : :::: ' + JSON.stringify(self.state.leagues));
                }.bind(self), 250);
            setTimeout(
                function () {
                    self.setState({ loadingLeagues: false })
                }.bind(self), 300);
        })

        setTimeout(
            function () {
                self.setState({ loading: false })
                console.log('LEAGUES : :::: ' + JSON.stringify(self.state.leagues));
            }.bind(self), 550);

        // ******* TO BE USED FOR RETREVING EVENTS INSIDE OF A SPECFIC LEAGUE *********** //

        // SWITCH TO params.leagueId 
        // LeagueStore.queryLeagueEvents("5be0b1053746572cf05a8fe7").then(async () => {
        //     setTimeout(() => {
        //         console.log("League Events: " + JSON.stringify(Array.from(LeagueStore.leagueEvents.values())))
        //     }, 1000)
        // });

        // ****************************************** //

    }

    async componentDidUpdate() {
        const { CategoriesStore, LeagueStore, categoryId } = this.props;
        let self = this;
        if (categoryId !== self.state.categoryId) {
            self.setState({ loading: true })
            self.setState({ categoryId: categoryId })
            CategoriesStore.querySingleCategory(categoryId).then(async () => {

                setTimeout(
                    function () {

                        self.setState({ category: Array.from(CategoriesStore.singleCategory.values()) });
                        self.state.category.forEach(function (category) {
                            self.props.ViewStore.changeView(category.title);
                        });
                    }.bind(self), 200);
            });

            CategoriesStore.queryCategoryEvents(categoryId).then(async () => {
                setTimeout(
                    function () {
                        self.setState({ events: Array.from(CategoriesStore.categoryEvents.values()) })
                    }.bind(self), 150);


            });

            LeagueStore.queryCategoryLeagues(categoryId).then(async () => {
                setTimeout(
                    function () {
                        self.setState({ leagues: Array.from(LeagueStore.categoryLeagues.values()) })
                        console.log('LEAGUES : :::: ' + JSON.stringify(self.state.leagues));

                    }.bind(self), 200);
                setTimeout(
                    function () {
                        self.setState({ loadingLeagues: false })
                    }.bind(self), 250);
            })


        }
    }

    renderEvent(event) {
        let time = new Date().getTime() / 1000;
        let startTime = new Date();
        startTime.setTime(event.startTime * 1000);
        let startTimeString = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();
        return (
            <EventCards
                key={event._id}
                event_id={event._id}
                event={event}
                bytes32_id={event.bytes32Id}
                start_time={startTimeString}
                start_time_number={event.startTime}
                duration={event.duration}
                categoryId={event.categoryId}
                team_one={event.teams[0]}
                team_two={event.teams[1]}
                drawPossible={event.drawPossible}
                betsForTeamOne={event.betsForTeamOne}
                betsForTeamTwo={event.betsForTeamTwo}
                amountBetForOne={event.amountBetForOne}
                amountBetForTwo={event.amountBetForTwo} />

        );
    }

    renderEventComponent() {
        const { CategoriesStore } = this.props;

        let eventList = [];
        let timeNow = new Date().getTime() / 1000;


        for (let event of Array.from(CategoriesStore.categoryEvents.values())) {

            if (event.startTime + event.duration > timeNow) {
                if (!event.cancelled && !event.finalized && !event.isPropEvent) {
                    eventList.push(this.renderEvent(event));
                }
            }
        }
        return eventList;
    }

    handleClickGridList() {
        this.props.ViewStore.changeGridList()
    }

    render() {
        const { categoryId } = this.props;



        let gridColumnEvents = "";
        let gridListIcon = "";

        if (this.props.ViewStore.getHeaderState === true) {
            gridColumnEvents = '100%';

        } else {
            if (this.props.ViewStore.getGridList === "list") {
                gridListIcon = <Icon type="appstore" onClick={this.handleClickGridList} />
                gridColumnEvents = '100%';
            } else {
                gridListIcon = <Icon type="bars" onClick={this.handleClickGridList} />
                gridColumnEvents = '49.3% 49.3%';
            }
        }

        let categoryLeagues = ""

        if (!this.state.loadingLeagues) {

            categoryLeagues = <CategoryLeaguesCarousel leagues={this.state.leagues} />

        }

        return (
            <div>

                <div className="view-options" style={{ marginTop: '-52px' }}>
                <div style={{ margin: '-5px 9px 0px 0px' }}><FollowCategoryBtn categoryId={categoryId} /></div>

                    <div className="grid-list-switch"><Switch onChange={this.switchChange} checkedChildren="BETTING" unCheckedChildren="ORACLES" defaultChecked /></div>
                    <div className="grid-list-icon">{gridListIcon}</div>
                </div>
                {categoryLeagues}

                <div className="main-page-cards" style={{ gridTemplateColumns: gridColumnEvents }}>
                    {this.renderEventComponent()}

                </div>
            </div>
        );
    }
}

export default CategoryEventCards;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/CategoryEventCards.js